'use client'

import { useEffect, useState } from 'react'

import { SliderComponent } from '../../../shared/ui-kit/actual/Slider'

interface ItemGalleryClientProps {
  imagesUrls?: string[]
  title?: string
}

export function ItemGalleryClient({ imagesUrls, title }: ItemGalleryClientProps) {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient || !imagesUrls?.length) {
    return null
  }

  return (
    <SliderComponent
      items={imagesUrls.map((image, index) => (
        <img
          alt={title || 'product'}
          height={425}
          key={index}
          src={image}
          style={{ objectFit: 'contain' }}
          width={'100%'}
        />
      ))}
      slidesToShow={1}
      dots
    />
  )
}
